const locale = require('./collaborationNote.i18n.json');

/*@ngInject*/
const CollaborationNoteEditorController = function ($scope, $uibModal, attachmentUtil) {
    let originalViewModel = {};

    this.i18n = locale;
    this.attachmentTypePlaceholder = this.i18n.type;

    this.$onInit = function () {
        this.initData();
    };

    this.resetViewModel = function () {
        this.isDirty = false;
        originalViewModel = _.clone(this.note);
        this.viewModel.note.isEditorSaving = false;
    };

    this.getDisplayedTime = function () {
        let roundedTimeCreated, roundedLastModified;

        if (this.note) {
            if (this.note && this.note.timeCreated && this.note.lastModified) {
                return this.note.lastModified;
            }

            return this.note.timeCreated;
        }
    };

    this.showDeleteConfirm = function () {

        let options = {
            title: this.i18n.deleteNoteTitle,
            summary: this.i18n.deleteQuestion,
            cancelButtonLabel: this.i18n.cancelActionButtonLabel,
            confirmActionButtonLabel: this.i18n.confirmActionButtonLabel
        };

        let modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            backdrop: 'static',
            windowClass: 'genericModal',
            resolve: {
                options: function () {
                    return options;
                }
            }
        });

        modalInstance.result.then(deleteNote.bind(this));

        function deleteNote() {
            if (this.note && this.note.id) {
                this.onDeleteNote({noteId: this.note.id});
            }
        }
    }

    this.onDeleteClick = function () {
        if (this.note.id && this.canDelete) {
            this.showDeleteConfirm();
        }
    };

    this.initData = function () {
        this.resetViewModel();

        attachmentUtil.getAttachmentTypes().then((result) => {
            let attachmentType = this.note.type || {};
            this.typeDataItems = result;
            this.selectedAttachmentType = _.find(result, {name: attachmentType});
        });

        if (this.note && this.note.id) {
            originalViewModel = _.clone(this.note);
        }
    }

    this.resetAndClose = function () {
        this.resetViewModel();
        this.onCloseNoteEditor();
    }

    this.doDirtyCheck = function () {
        let isDirty = false;
        if (originalViewModel.text !== this.note.text) {
            isDirty = true;
        }
        if (originalViewModel.publicNote !== this.note.publicNote) {
            isDirty = true;
        }
        if (_.isEmpty(this.note.text)) {
            isDirty = false;
        }
        if ((!_.isNil(this.selectedAttachmentType) && this.selectedAttachmentType.type !== this.note.type) ||
            (_.isNil(this.selectedAttachmentType) && !_.isNil(this.note.type))) {
            isDirty = true;
        }
        this.isDirty = isDirty;
    }

    this.onUpdateSelectedType = function () {
        this.doDirtyCheck();
        this.onBlur();
    };

    this.onSaveClick = function () {
        this.note.type = !_.isNil (this.selectedAttachmentType) ? this.selectedAttachmentType.name:'';
        this.onCreateNote({data: this.note});
    };

    this.onCancelClick = function () {
        this.resetAndClose();
    };

    this.onChange = function () {
        this.doDirtyCheck();
        this.onBlur();
    };

    this.onTextareaChange = function () {
        this.doDirtyCheck();
    };

    this.onBlur = function () {
        if (this.isExistingNote && this.isDirty) {
            this.note.type = !_.isNil (this.selectedAttachmentType) ? this.selectedAttachmentType.name:'';
            this.onUpdateNote({noteId: this.note.id, data: this.note});
            this.initData();
        }
    };

    this.$onChanges = function (changes) {
        if (!_.isNil(changes.note.currentValue)) {
            this.initData();
        }
    };
};

angular.module('gw-um-submission')
    .controller('collaborationNoteEditorController', CollaborationNoteEditorController);
